export const OctoAmountTypesEnum = {
  Static: '01',
  Dyanmic: '02',
};
